export default __webpack_public_path__ + "static/media/marker-selected.0da2e990.svg";